import {Nav, Navbar, NavbarBrand, NavDropdown} from "react-bootstrap";
import {LogOut, Menu, User} from "react-feather";

import {useUser} from '../contexts/UserProvider';
import profile from "../assets/img/illustrations/profiles/profile-7.png"
import useTranslation from "../hooks/translations";
import config from '../config/config.json';
import {useSidebarState} from "../contexts/SidebarStateProvider";
import {useNavigate} from "react-router-dom";

export default function TopNavigationBar() {
  const {user, logout} = useUser();
  const translations = useTranslation();
  const {sidebarState, setSidebarState} = useSidebarState();

  const onToggleSidebar = (event) => {
    event.preventDefault();
    document.body.classList.toggle('sidenav-toggled');
    localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sidenav-toggled'));
  };

  let navigate = useNavigate();
  const onProfilClick = async (event) => {
    setSidebarState({
      ...sidebarState,
      isAccountSettingsOpen: true
    })
    navigate("/account-profile");
  }

  const onAppTitleClick = async (event) => {
    navigate("/incomes");
  }

  return (
    <>
      {user &&
        <Nav id="sidenavAccordion"
             className="topnav navbar navbar-expand shadow justify-content-between justify-content-sm-start navbar-light bg-white">
          <button
            className="btn btn-icon btn-transparent-dark order-1 order-lg-0 me-2 ms-lg-2 me-lg-0"
            id="sidebarToggle" onClick={onToggleSidebar}>
            <Menu/>
          </button>
          <NavbarBrand>
            <a className="navbar-brand pe-3 ps-4 ps-lg-2"
               onClick={onAppTitleClick}
               role="button">{config.appTitle}
            </a>
          </NavbarBrand>
          <Navbar className="navbar-nav align-items-center ms-auto">
            <NavDropdown
              title={<div
                id="navbarDropdownUserImage"
                href=""
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                className="btn btn-icon btn-transparent-dark"
              >
                <img className="img-fluid" src={profile} alt="profile"/>
              </div>
              }
              id="basic-nav-dropdown" className="dropdown-user">
              <NavDropdown.Header>
                <img className="dropdown-user-img" src={profile} alt="profile"/>
                <div className="dropdown-user-details">
                  <div
                    className="dropdown-user-details-name">{`${user.first_name} ${user.last_name}`}</div>
                  <div
                    className="dropdown-user-details-email">{user.email}</div>
                </div>
              </NavDropdown.Header>
              <NavDropdown.Divider></NavDropdown.Divider>
              <NavDropdown.Item onClick={onProfilClick}
                                className="dropdown-item">
                <div className="dropdown-item-icon">
                  <User/>
                </div>
                {translations.account}
              </NavDropdown.Item>
              <NavDropdown.Item href="#" className="dropdown-item"
                                onClick={logout}>
                <div className="dropdown-item-icon">
                  <LogOut/>
                </div>
                {translations.logout}
              </NavDropdown.Item>
            </NavDropdown>
          </Navbar>
        </Nav>
      }
    </>
  );
}
